<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>
    <v-row>
      <v-col cols="12" sm="4">
        <AutocompleteComp @change="getAllGradosAdmin(filtro.id_nivel)" v-model="filtro.id_nivel" textLabel="Nivel"
          :items="NivelesAdmin" item-value="id_nivel_adm_nivel" item-text="desc_nivel" />
      </v-col>

      <v-col cols="12" sm="4">
        <AutocompleteComp @change="getAllSeccionesGrados(filtro.id_grado)" v-model="filtro.id_grado" textLabel="Grado"
          :items="GradosAdmin" item-value="id" item-text="desc_grado" />
      </v-col>
      <v-col cols="12" sm="4">
        <AutocompleteComp @change="getAllCursosGrados(filtro.id_seccion)" v-model="filtro.id_seccion" textLabel="Sección"
          :items="SeccionGrado" item-value="id" item-text="nombre_seccion" />
      </v-col>
    </v-row>
    <div class="d-flex">
      <v-container>
        <v-row wrap>
          <v-col cols="12" v-if="cursosSecciones < 1">
            <v-card outlined>
              <v-card-text style="height:500px" class="text-center d-flex justify-center align-center">
                <span class="">
                  Aún no se ha agregado cursos a ésta sección
                </span>
              </v-card-text>
            </v-card>
          </v-col>       
          <v-col cols="12" sm="4" md="3" class="d-flex justify-center" v-for="item in cursosSecciones" :key="item.id">
            <v-card width="240" elevation="7" :style="{ 'border-left': 'solid 5px' + item.color_curso }">
              <v-list-item>
                <v-list-item-avatar class="ml-0 mr-1" size="50" :color="item.color_curso">
                  <v-icon dark>{{ item.icono_curso }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0">
                  <span class="mb-1 font-weight-bold black--text">{{
                    item.desc_curso
                  }}</span>
                  <v-list-item-title class="caption">Área: {{ item.desc_area }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-card-text class="py-1"  style="background-color:#eaeaea" >
                <v-row dense>
                  <v-col cols="12" class="text-center "  id="text">
                    {{ item.desc_nivel }} - {{
                      item.desc_grado }}
                  </v-col>
                  <v-col cols="12" class="text-center "  id="text">
                    {{
                      item.nombre_pers ? item.nombre_pers : "Sin docente"
                    }}
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row dense>
                  <v-col cols="12" class="d-flex justify-center">
                      <v-btn
                        small
                        color="warning"
                        class="ma-2 white--text"
                        @click="openModalprogramarTemario(item)"
                        >
                      <v-icon left dark>
                        mdi-book-open-page-variant
                      </v-icon>
                        Programar temario
                    </v-btn>
                  </v-col>  
                  </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>        
    </v-container>
    </div>
    <component :is="compName" :estadoComp="estadoC" :parametros="parametroC" @close="estadoC = false">
    </component>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations } from "vuex";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";
import ButtonComp from '../../../components/ComponentsEst/TableButtonComp.vue';
import modalTemarioDocente from "./components/modalDocenteTemarioPlan.vue";

export default {
  components: {
    AutocompleteComp,
    ButtonComp,
    modalTemarioDocente
  },
  data() {
    return {
      datoLogin: sessionStorage,
      filtro: {
        id_nivel: 0,
        id_grado: 0,
        id_seccion: 0,
      },
      NivelesAdmin: [],
      GradosAdmin: [],
      SeccionGrado: [],
      cursosSecciones: [],
      // componente General
      compName: null,
      estadoC: true,
      parametroC: {},     
    };
  },  
  mounted() {
    this.getAllNivelesAdmin();   
  },
  methods: {
    ...mapMutations({
            setEnviarMens: "mensajeSis/setEnviarMens",
        }),
    /** 
     ___________________________________________________
    |     MÉTODO OBTENER NIVELES DE ADMINISTRACION    */
    async getAllNivelesAdmin() {
      let params = {
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        id_colegio: this.datoLogin.id_colegio,
      };

      try {
        let response = await axios.post(
          "/administrativo/asignacionDocenteCurso/getNivel/",
          params
        );
        this.NivelesAdmin = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     ____________________________________________________________
    |     MÉTODO OBTENER GRADOS DE ADMINISTRACION POR NIVEL    */
    async getAllGradosAdmin(id_nivel) {
      this.cursosSecciones = [];
      let params = {
        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        id_nivel,
      };

      try {
        let response = await axios.post(
          "/administrativo/grado/gradosNivelAdmin/",
          params
        );
        this.GradosAdmin = response.data;
       
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     _____________________________________________________________
    |     MÉTODO OBTENER SECCION DE ADMINISTRACION POR GRADO    */
    async getAllSeccionesGrados(id_grado) {
      
      this.cursosSecciones = [];
      let params = {
        id_colegio: this.datoLogin.id_colegio,
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        id_grado,
      };
      try {
        let response = await axios.post(
          "/administrativo/seccion/seccionGrado/",
          params
        );
        this.SeccionGrado = response.data;
     
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     ______________________________________________________________
    |     MÉTODO OBTENER CURSOS DE ADMINISTRACION POR SECCION    */
    async getAllCursosGrados(id) {
      this.cursosSecciones = [];
      
      let params = {
        id_colegio: sessionStorage.id_colegio,
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_seccion: id,
      };
      try {
        let response = await axios.post(
          "/administrativo/asignacionDocenteCurso/cs/list/",
          params
          );
          this.cursosSecciones = response.data;
      
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
    /** 
     ____________________________________________
    |     MÉTODO ABRIR COMPONENTE TEMARIOS     */
    openModalprogramarTemario(item){

      let params = {
          datos: item
      }
      
      this.parametroC = params
      this.compName = "modalTemarioDocente"
      this.estadoC = true

      console.log({item});

    }, 
  },
}    
</script>

